import { CAROUSEL_TYPE } from 'consts/enum';

export const launchCards = {
	type: CAROUSEL_TYPE.HORIZONTAL,
};
